import { Container, Grid, Paper } from '@material-ui/core'
import React, { useState } from 'react'
import { components, useTranslation } from 'cng-web-lib'

import AccessLevelCompanyViewForm from './AccessLevelCompanyViewForm'
import AccessLevelCompanyAddForm from './AccessLevelCompanyAddForm'
import AccessLevelCompanyEditForm from './AccessLevelCompanyEditForm'
import AccessLevelCompanyRuleCrudTable from './AccessLevelCompanyRuleCrudTable'
import Namespace from 'src/constants/locale/Namespace'
import AccessLevelCompanyKeys from 'src/constants/locale/key/AccessLevelCompany'
import {
  constants,
} from 'cng-web-lib'

const {
  locale: {
    key: {
      UiComponentKeys,
    },
  },
} = constants

const { CngTabs } = components

function AddPage({ history, showNotification }) {
  const [lockedOnFirstTab, setLockedOnFirstTab] = useState(true)
  const [accessLevelCompanyId, setAccessLevelCompanyId] = useState('')
  const { translate } = useTranslation([
    Namespace.ACCESS_LEVEL_COMPANY,
    Namespace.UI_COMPONENT
  ])
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let accessLevelCompany = translate(
      Namespace.ACCESS_LEVEL_COMPANY,
      AccessLevelCompanyKeys.TITLE
    )
    let accessLevelCompanyRule = translate(
      Namespace.ACCESS_LEVEL_COMPANY,
      AccessLevelCompanyKeys.AccessLevelCompanyRule.TITLE
    )
    let tabLockedMessage = translate(
      Namespace.UI_COMPONENT,
      UiComponentKeys.Tabs.PLEASE_SUBMIT_FIRST,
      {
        title: accessLevelCompany
      }
    )

    return {
      accessLevelCompany,
      accessLevelCompanyRule,
      tabLockedMessage
    }
  }

  function makeAccessLevelCompanyForm() {
    if (accessLevelCompanyId === '') {
      return (
        <AccessLevelCompanyAddForm
          history={history}
          showNotification={showNotification}
          onPostSubmitSuccess={(datum) => {
            setAccessLevelCompanyId(datum.id)
            setLockedOnFirstTab(false)
          }}
        />
      )
    } else {
      return (
        <AccessLevelCompanyEditForm
          showNotification={showNotification}
          id={accessLevelCompanyId}
        />
      )
    }
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper>
          <Container maxWidth='xl'>
            <AccessLevelCompanyViewForm
              showNotification={showNotification}
              id={accessLevelCompanyId}
            />
          </Container>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <CngTabs
          headerColor='primary'
          tabs={[
            {
              tabName: translatedTextsObject.accessLevelCompany,
              tabContent: makeAccessLevelCompanyForm()
            },
            {
              tabName: translatedTextsObject.accessLevelCompanyRule,
              tabContent: (
                <AccessLevelCompanyRuleCrudTable
                  showNotification={showNotification}
                  accessLevelCompanyId={accessLevelCompanyId}
                />
              )
            },
          ]}
          lockedOnFirstTab={lockedOnFirstTab}
          tabLockedMessage={translatedTextsObject.tabLockedMessage}
        />
      </Grid>
    </Grid>
  )
}

export default AddPage